import React, { useEffect } from 'react'
import Input from "../../../../../core/Inputs/DefaultInput";
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader';
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar';
import SubHeader from '../../../../../component/common/layout/SubHeader';
import { Link } from 'react-router-dom'
import Select from 'react-select';
import { useVerifySurveyId } from "../../../../../hooks";
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import { apiRequest } from "../../../../../services/apiService";
import { useTranslation } from 'react-i18next';


export default function Questionaire() {
    const { survey_name } = useSelector((state) => state.permissionsData)
    const survey_id = useVerifySurveyId()
    const [surveyLayout, setSurveyLayout] = React.useState(1);
    const [pageHeading, setPageHeading] = React.useState('');
    const [buttonHeading, setButtonHeading] = React.useState('');
    const [buttonNext, setButtonNext] = React.useState('');
    const [buttonBack, setButtonBack] = React.useState('');

    // Report
    const [assessment, setAssessment] = React.useState('');
    const [assessmentHeading, setAssessmentHeading] = React.useState('');
    const [stage, setStage] = React.useState('');
    const [stage1, setStage1] = React.useState('');
    const [stage2, setStage2] = React.useState('');
    const [stage3, setStage3] = React.useState('');
    const [stage4, setStage4] = React.useState('');
    const [stage5, setStage5] = React.useState('');






    const { t, i18n } = useTranslation();

    const save = () => {

        const payload = {
            "su_survey_id": survey_id,
            "page_heading": pageHeading,
            "button_heading": buttonHeading,
            "button_next": buttonNext,
            "button_back": buttonBack,
            "reportPage6_assessment": assessment,
            "reportPage6_assessmentHeading": assessmentHeading,
            "reportPage6_stage": stage,
            "reportPage6_stage1": stage1,
            "reportPage6_stage2": stage2,
            "reportPage6_stage3": stage3,
            "reportPage6_stage4": stage4,
            "reportPage6_stage5": stage5
            
        }

        postData(payload);

    };

    const postData = async function (payload) {
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/updateQuestionaire`,
            data: payload,
            showErrorToast: false
        })
        if (response) {
            console.log(response)
            if (response.data.statusCode == 200) {
                localStorage.setItem('token_id', response.data.token);
                toast.success(response.data.msg);
            } else {
                localStorage.setItem('token_id', response.data.token);
                toast.error(response.data.msg);
            }
        }
        else if (error) {
            toast.error(error);
        }

    }

    const getQuestionaire = async () => {

        let payload = {
            su_survey_id: survey_id
        }
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/getQuestionaire`,
            data: payload,
            showErrorToast: false
        })
        if (response) {
            console.log(response)
            if (response.data.statusCode == 200) {

                setPageHeading(response.data.data[0].questionaire_heading);
                setButtonHeading(response.data.data[0].questionaire_button_heading);
                setButtonNext(response.data.data[0].questionaire_button_next);
                setButtonBack(response.data.data[0].questionaire_button_back);
                setAssessment(response.data.data[0].reportPage6_assessment);
                setAssessmentHeading(response.data.data[0].reportPage6_assessmentHeading);
                setStage(response.data.data[0].reportPage6_stage);
                setStage1(response.data.data[0].reportPage6_stage1);
                setStage2(response.data.data[0].reportPage6_stage2);
                setStage3(response.data.data[0].reportPage6_stage3);
                setStage4(response.data.data[0].reportPage6_stage4);
                setStage5(response.data.data[0].reportPage6_stage5);

                localStorage.setItem('token_id', response.data.token);
            } else {
                localStorage.setItem('token_id', response.data.token);
                toast.error("Something went wrong, please try again.");
            }
        }
        else if (error) {
            toast.error(error);
        }
    }

    useEffect(() => {
        if (survey_id) {
            getQuestionaire();
        }
    }, [survey_id])

    return (
        <>
            <div id="content" className='flex-grow-1 dashboard-page-outer'>
                <div className="survey-main-container">
                    <div className="page-heading">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/admin/survey/list">{t('survey.title')}</Link>
                                </li>
                                <li className="breadcrumb-item"><Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link></li>
                                <li className="breadcrumb-item active" aria-current="page"><strong>{t('settings.questionnaire.title')}</strong></li>
                            </ol>
                        </nav>
                        <h1>{t('settings.questionnaire.title')}</h1>
                    </div>
                    <div className="survey-container">
                        <div className="form-preview-wrapper padding-top-30">
                            <div className='form-wraper'>
                                <div className='form-inner'>

                                    <div className='row gx-12px'>
                                        <div className='col-lg-12'>
                                            <div className='quest-pg-heading'>
                                               </div>
                                        </div>
                                        <div className='col-lg-12 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.pageHeading')} </label>
                                                <textarea className="form-control" placeholder={t('settings.questionnaire.title')} rows={3} defaultValue={""}
                                                    value={pageHeading}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setPageHeading(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row gx-12px'>

                                        <div className='col-lg-4 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.buttonNextText')} </label>
                                                <input className="form-control" placeholder={t('settings.questionnaire.buttonNextText')} rows={5} defaultValue={""}
                                                    value={buttonNext}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setButtonNext(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-4 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.buttonHeadingText')} </label>
                                                <input className="form-control" placeholder={t('settings.questionnaire.buttonHeadingText')} rows={5} defaultValue={""}
                                                    value={buttonHeading}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setButtonHeading(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-4 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.buttonBack')} </label>
                                                <input className="form-control" placeholder={t('settings.questionnaire.buttonBack')} rows={5} defaultValue={""}
                                                    value={buttonBack}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setButtonBack(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    <div className='row gx-12px'>
                                        <div className='col-lg-12'>
                                            <div className='quest-pg-heading'>{t('settings.questionnaire.report')}</div>
                                        </div>
                                        <div className='col-lg-12 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.reportPageHeading')}</label>
                                                <textarea className="form-control" placeholder={t('settings.questionnaire.reportPageHeading')} rows={3} defaultValue={""}
                                                    value={assessment}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setAssessment(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    <div className='row gx-12px'>
                                        <div className='col-lg-12 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.reportHeading')}</label>
                                                <textarea className="form-control" placeholder={t('settings.questionnaire.reportHeading')} rows={3} defaultValue={""}
                                                    value={assessmentHeading}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setAssessmentHeading(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row gx-12px'>
                                        <div className='col-lg-12 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.stage')}</label>
                                                <textarea className="form-control" placeholder={t('settings.questionnaire.stage')} rows={3} defaultValue={""}
                                                    value={stage}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setStage(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    <div className='row gx-12px'>
                                        <div className='col-lg-4 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.stage1')}</label>
                                                <textarea className="form-control" placeholder={t('settings.questionnaire.stage1')} rows={2} defaultValue={""}
                                                    value={stage1}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setStage1(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                    
                                        <div className='col-lg-4 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.stage2')}</label>
                                                <textarea className="form-control" placeholder={t('settings.questionnaire.stage2')} rows={2} defaultValue={""}
                                                    value={stage2}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setStage2(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                    
                                        <div className='col-lg-4 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.stage3')}</label>
                                                <textarea className="form-control" placeholder={t('settings.questionnaire.stage3')} rows={2} defaultValue={""}
                                                    value={stage3}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setStage3(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                    
                                        <div className='col-lg-4 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.stage4')}</label>
                                                <textarea className="form-control" placeholder={t('settings.questionnaire.stage4')} rows={2} defaultValue={""}
                                                    value={stage4}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setStage4(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                    
                                        <div className='col-lg-4 position-relative'>
                                            <div className="form-group mb__20">
                                                <label className='form-label-custom'>{t('settings.questionnaire.stage5')}</label>
                                                <textarea className="form-control" placeholder={t('settings.questionnaire.stage5')} rows={2} defaultValue={""}
                                                    value={stage5}
                                                    onChange={window.modulePermissions.M21.edit == 1 ? (e) => setStage5(e.target.value) : undefined}
                                                    readOnly={window.modulePermissions.M21.edit != 1}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="button-wrap pt-2">

                                        {window.modulePermissions.M21.edit == 1 && (<button className="btn btn-primary next-btn"
                                            type="button"
                                            onClick={() => save()}
                                        >{t('settings.questionnaire.save')}</button>)}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
